import React, { useContext, useState } from 'react';
import { Modal, Form, Button, Checkbox, Dropdown } from 'semantic-ui-react';
import api from '../../apis/api';
import { Editor } from '@tinymce/tinymce-react';
import { Config } from '../TinyEditorConfig';

import UserContext from '../../contexts/UserContext';
import { SuccessToast, ErrorToast } from '../Toasters';

const UserProfile =({userModal, closeModal})=> {

    const userContext = useContext(UserContext)
    const [darkMode, setDarkMode] = useState(userContext.userInfo.darkMode)
    const [region, setRegion] = useState(userContext.userInfo.region)
    const [signature, setSignature] = useState(userContext.userInfo.signature)

    function onSubmit(event){
        event.preventDefault()
        const data = new FormData(event.target);
        const dict={};
        dict.signature = signature
        for(let [key,value] of data.entries()){
            dict[key]=value
        }
        dict.region = region
        dict.darkMode = darkMode
        api.put('/userprofiles', dict)
        .then(r=>{
            SuccessToast("Updated Profile", "Your User Profile has been updated")
            closeModal()
            userContext.setDarkMode(darkMode)
        })
        .catch(err => {ErrorToast(err)})
    }

    const regionList = [
        {key: 'canada', text: "Canada", value: 'Canada'},
        {key: 'india', text: "India", value: 'India'},
        {key: 'usa', text: "USA", value: 'USA'},
    ]
    return (
        <Modal
        open={userModal}
        onClose={() =>closeModal()}
        >

        <Modal.Header>Profile Information</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                <Form onSubmit={onSubmit}>

                        <Form.Group widths='equal'>

                            <Form.Field>
                                <label>Full Name</label>
                                <input name='fullname' defaultValue={userContext.userInfo.fullname} />                        
                            </Form.Field>
                            
                            <Form.Field>
                                <label>Company</label>
                                <input name='cLabel' defaultValue={userContext.userInfo.cLabel} />                        
                            </Form.Field>
                        </Form.Group>
                        <Form.Group>
                            <Form.Field width={6}>
                                <label>Phone number</label>
                                <input type='tel' name='phone' pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" placeholder='123-456-7890'defaultValue={userContext.userInfo.phone} />                        
                            </Form.Field>
                            <Form.Field width={4}>
                                <label>Zip</label>
                                <input defaultValue={userContext.userInfo.zip} name='zip'/>
                            </Form.Field>
                            <Form.Field width={4}>
                                <label>Region</label>
                                <Dropdown fluid selection search
                                    placeholder="Region"
                                    options={regionList.sort((a, b) => a.text.localeCompare(b.text))}
                                    value={region}
                                    onChange={(e,d) => setRegion(d.value)}
                                />
                            </Form.Field>
                            <Form.Field width={2}>
                            <label>Dark Mode</label>
                            <Checkbox
                                toggle 
                                name='darkMode'
                                defaultChecked={darkMode} 
                                onChange={(e,d)=>setDarkMode(d.checked)}
                            />
                        </Form.Field>
                        </Form.Group>
                        <Form.Field>
                            <label>Signature</label>
                            <Editor
                                init={Config}
                                value={signature}
                                onEditorChange={(v) => setSignature(v)}
                            />
                        </Form.Field>

                        <Button
                            content="Save Changes"
                            labelPosition='right'
                            icon='checkmark'
                            positive
                            type='submit'
                            floated="left"

                        />
                        <Button
                            content="Close"
                            labelPosition="left"
                            icon="close"
                            floated="right"
                            primary
                            onClick={() => closeModal()}
                        />
                </Form>
                </Modal.Description>
            </Modal.Content>

    </Modal>
    )

    }
    export default UserProfile
